var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import * as styles from './PriceBarMobile.scss';
import PriceContainer from '@idp/ui-components/components/cards/PriceContainer/PriceContainer';
import { PricingType } from '@idp/ui-components/components/cards/PriceContainer/PriceContainerProps';
import getTestId from '@idp/ui-components/utils';
import Tooltip from '@idp/ui-components/components/atoms/Tooltip';
import { TooltipTypes } from '@idp/ui-components/components/atoms/Tooltip/TooltipProps';
import Label from '@idp/ui-components/components/atoms/Label/Label';
import { LabelSizes } from '@idp/ui-components/components/atoms/Label/LabelProps';
import { history } from '@idp/routables';
import PriceBarService from '../PriceBarService';
var PriceBar = /** @class */ (function (_super) {
    __extends(PriceBar, _super);
    function PriceBar(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            currentWidth: window.innerWidth,
            displayToolTip: false,
        };
        _this.blur = _this.blur.bind(_this);
        _this.focus = _this.focus.bind(_this);
        _this.onDisabledButtonClick = _this.onDisabledButtonClick.bind(_this);
        return _this;
    }
    PriceBar.prototype.blur = function () {
        if (!this.props.data.buttonData.enabled && this.props.data.buttonData.disableToolTipText) {
            this.setState({ displayToolTip: false });
        }
    };
    PriceBar.prototype.focus = function () {
        if (!this.props.data.buttonData.enabled && this.props.data.buttonData.disableToolTipText) {
            this.setState({ displayToolTip: true });
        }
    };
    PriceBar.prototype.onDisabledButtonClick = function () {
        if (window.location.href.indexOf('wireless') !== -1) {
            window.sessionStorage.setItem('goToCartDialogInfo', 'enabled');
            this.setState({ displayToolTip: false });
            history.push('insuranceinfo');
        }
    };
    PriceBar.prototype.render = function () {
        var _this = this;
        var dataToday = {
            // billingNote: this.props.data.todayPriceLabel || 'due today',
            price: this.props.data.todayPrice,
        };
        var dataMonthly = {
            // billingNote: this.props.data.monthlyPriceLabel || 'per month',
            price: this.props.data.monthlyPrice,
        };
        var oneTimeCharge = {
            // billingNote: this.props.data.firstBillPriceLabel || 'due first',
            price: this.props.data.oneTimeCharge,
        };
        var buttonEvents = {
            // onBlur : this.blur,
            onClick: this.props.events.onButtonClick,
        };
        var buttonData = this.props.data.buttonData;
        var decPoints = this.props.data.decimalPoints || 0;
        return (React.createElement("div", { "data-test-id": this.props.testId, className: styles.stickyBarWrapper },
            React.createElement("div", { className: styles.priceContainer },
                this.props.data.monthlyPrice !== undefined && this.props.data.monthlyPrice !== null &&
                    React.createElement("div", null,
                        React.createElement("span", { className: styles.smallheading }, this.props.data.monthlyPriceLabel || 'Due monthly'),
                        React.createElement("span", { className: [styles.smallPriceContainer, styles.lineHeight24].join(' ') },
                            React.createElement(PriceContainer, { testId: getTestId(this.props.testId, 'PriceContainer', 'MonthlyPrice'), data: dataMonthly, options: {
                                    decimalPoints: decPoints,
                                    showAbsolute: this.props.options.showAbsolute,
                                    type: PricingType.PERMONTH,
                                } }))),
                (this.props.data.todayPrice !== undefined) &&
                    React.createElement("div", null,
                        React.createElement("span", { className: styles.smallheading }, this.props.data.todayPriceLabel || 'Due today'),
                        React.createElement("span", { className: [styles.smallPriceContainer, styles.lineHeight24].join(' ') },
                            React.createElement(PriceContainer, { testId: getTestId(this.props.testId, 'PriceContainer', 'TodayPrice'), data: dataToday, options: {
                                    decimalPoints: decPoints,
                                    showAbsolute: this.props.options.showAbsolute,
                                    type: PricingType.DUETODAY,
                                } }))),
                this.props.data.oneTimeCharge !== undefined && this.props.data.oneTimeCharge != null &&
                    React.createElement("div", null,
                        React.createElement("span", { className: styles.smallheading }, this.props.data.oneTimeChargeLabel || 'One time charges'),
                        React.createElement("span", { className: [styles.smallPriceContainer, styles.lineHeight24].join(' ') },
                            React.createElement(PriceContainer, { testId: getTestId(this.props.testId, 'PriceContainer', 'FirstPrice'), data: oneTimeCharge, options: {
                                    decimalPoints: decPoints,
                                    showAbsolute: this.props.options.showAbsolute,
                                    type: PricingType.PERMONTH,
                                } })))),
            (this.props.data.monthlyPrice !== undefined || this.props.data.oneTimeCharge !== undefined ||
                this.props.data.showExcludedTaxLabel) &&
                React.createElement("div", { className: styles.priceBarExclusive },
                    React.createElement(Label, { data: { text: this.props.data.excludedTaxLabel || '*Excludes taxes & fees' }, options: { size: LabelSizes.LEGALCOPY, className: styles.priceBarLabel } })),
            React.createElement("div", { className: styles.priceBarButton, onFocus: this.focus, onBlur: this.blur, onMouseOver: this.focus, onMouseOut: this.blur, ref: function (ref) { _this.ref = ref; } },
                PriceBarService.renderButton(this.props, buttonData, buttonEvents),
                React.createElement(Tooltip, { data: { type: TooltipTypes.FIXED_CONTROLLED, showTooltip: this.state.displayToolTip } },
                    React.createElement(Label, { data: { text: buttonData.disableToolTipText }, options: { size: LabelSizes.MEDIUMBODY } })))));
    };
    PriceBar.defaultProps = {
        options: {
            className: '',
            showAbsolute: false,
        },
    };
    return PriceBar;
}(React.Component));
export default PriceBar;
//# sourceMappingURL=PriceBarMobile.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/components/PriceBar/PriceBarSub/PriceBarMobile/PriceBarMobile.js
// module id = 2224
// module chunks = 8